import React, { useRef } from 'react'
import { Banner } from '../../common'

import { extend, useThree, useFrame } from "@react-three/fiber"
import { Html, shaderMaterial } from "@react-three/drei"
import { uniforms, fragmentShader, vertexShader } from "../Shaders"

import { gsap } from "gsap"

import { useTranslation } from 'react-i18next'

const PolySphereMaterial = shaderMaterial(
    {},
    vertexShader,
    fragmentShader
);

extend({ PolySphereMaterial });

const Mesh = () => {
    // Material and Mesh References
    const materialRef = useRef();
    const meshRef = useRef();

    // Viewport Reference
    const { viewport } = useThree();

    useFrame(({ mouse }) => {
        const x = (mouse.x * viewport.width) / 10;
        const y = (mouse.y * viewport.width) / 10;
    
        meshRef.current.rotation.y += 0.005;
    
        gsap.to(materialRef.current.uniforms.uFrequency, { value: x });
        gsap.to(materialRef.current.uniforms.uAmplitude, { value: x });
        gsap.to(materialRef.current.uniforms.uDensity, { value: y });
        gsap.to(materialRef.current.uniforms.uStrength, { value: y });
        // gsap.to(materialRef.current.uniforms.uDeepPurple, { value: y });
    });

    return (
        <mesh 
            ref={meshRef} 
            scale={(viewport.width / 5) * (viewport.width < 7 ? 2.5 : 1.5)} 
            position={[0, 0.5, 0]}
        >
            <icosahedronGeometry args={[1, 64]} />
            <polySphereMaterial
                attach="material"
                ref={materialRef}
                fragmentShader={fragmentShader}
                vertexShader={vertexShader}
                uniforms={uniforms}
                wireframe={true}
                transparent={true}
            />
        </mesh>
    )   
}

const WebGL = () => {

    const { t } = useTranslation();
    return (
        <>  
            <Mesh />
            <Html fullscreen zIndexRange={[-1, -5]}>
                <Banner >
                    <div className="mt-20-per p-0d5-em">
                        {t('canvas_banner_1')} 
                        <i className="bold">{t('canvas_banner_2')}</i>
                        {t('canvas_banner_3')}
                        <span className="bold">{t('canvas_banner_4')}</span> 
                        <br /><br /><br />
                        nas #stillmatic
                    </div>
                </Banner>
            </Html>
        </>        
    )
}

export default WebGL